import Head from 'next/head'
import { Container } from 'components/ui'
import type { FC } from 'react'
import Layout, { Breadcrumb, BreadcrumbProps } from 'components/layout'
import { ProductListView } from 'modules/products/containers'
import { ProductService } from 'modules/products/services'
import { Product } from 'framework/products'
import parser from 'fazendinha/product'
import sellerParser from 'fazendinha/seller'
import { withRouter, NextRouter } from 'next/router'
import { SellerService } from 'modules/sellers/services'
import { Seller } from 'framework/sellers'
import { SellerProfile } from 'modules/sellers/components'
import { ROUTE_SELLER_INDEX } from 'routes/sellers'
// import Cookies from 'cookies'
import s from './produtores.module.css'
import Cookies from 'cookies'

interface HomeProps {
  products: Product[]
  seller: Seller
  router: NextRouter
  lastPage: number
}

interface Params {
  query: any
  params: {
    slug: string
  }
}

export const getServerSideProps = async (ctx: any) => {
  const {
    query,
    params: { slug },
  }: Params = ctx

  // const cookies = new Cookies(ctx.req, ctx.res)

  // const zipCode = cookies.get('zipcode') || ''
  const { page, days, orderby, sort, search } = query
  const searchParam = search || ''

  const productService = new ProductService()
  const sellerService = new SellerService()
  const sellerResponse = await sellerService.getBySlug(slug)
  const sellerData = sellerParser(sellerResponse.data.data)
  const cookies = new Cookies(ctx.req, ctx.res)
  const zipCode = cookies.get('zipcode')
  console.log("cookies: ", zipCode)

  try {
    const productQuery = {
      categories: '',
      page: page || 1,
      days,
      orderby,
      sort,
      search: searchParam,
      seller: sellerData.id,
      zipcode: zipCode,
    }

    const productsResponse = await productService.query(productQuery)
    console.log("productsResponse", productsResponse)
    return {
      props: {
        products: productsResponse.data.data.map((p: any) => parser(p)),
        lastPage: productsResponse.data.meta.last_page,
        seller: sellerData,
      },
    }
  } catch (e) {
    return {
      props: {
        products: [],
        lastPage: 1,
        seller: sellerData,
      },
    }
  }
}

const Home: FC<HomeProps> = ({ products, seller, lastPage, router: { asPath } }) => {
  const crumbs: BreadcrumbProps['crumbs'] = [{ url: ROUTE_SELLER_INDEX, label: 'Produtores' }]

  if (seller && seller.name) {
    crumbs.push({ label: seller.name })
  }

  return (
    <Layout>
      <Head>
        <title>{seller?.name || 'Produtores'}</title>
      </Head>
      <Breadcrumb crumbs={crumbs} />
      <Container className={s.root}>
        <SellerProfile seller={seller} withHeader />
        <ProductListView sellersPage lastPage={lastPage} filters={false} baseUrl={asPath} products={products} />
        <SellerProfile seller={seller} onlyInfo withHeader={false} />
      </Container>
    </Layout>
  )
}

export default withRouter(Home)
